import { Gender } from '@customTypes/Generic'
import { DisplayRole, PractitionerPosition } from '@customTypes/Practitioner'
import { useSmartTranslation } from '@hooks/useSmartTranslation'

export const useGetPractitionerRoles = (
  positions: PractitionerPosition[] | undefined,
  gender: Gender | undefined,
  displayRole: DisplayRole | undefined,
  language: string
) => {
  const { t } = useSmartTranslation()

  if (displayRole) {
    return displayRole[language as keyof DisplayRole]
  }

  if (!positions || !positions.length || !gender) return ''

  const roles = positions
    ?.map((position) => t(`employee_position_${position.role.toLocaleLowerCase()}_${gender?.toLocaleLowerCase()}`))
    .filter((roleName) => roleName !== null)

  if (roles.length === 0) {
    return ''
  }

  const rolesString = roles?.join(', ')

  return rolesString
}
